import DataLoad from "./src/index.vue";
import type { App } from "vue";
DataLoad.install = function (Vue: App): void {
  console.info("DataLoad----install----");
  Vue.component(DataLoad.name, DataLoad);
};

export default DataLoad;
